export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  DISMISSED_PLATFORM_BANNERS: 'dismissedPlatformBanners',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  DISMISSED_DEBT_STATE_WIDGET: 'debtStateWidgetDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  SIDEBAR_MINIMIZED_SECTIONS: 'sidebarMinimizedSections',
};
